import PropTypes from "prop-types";
import { PictureOutlined, DeleteOutlined } from "@/config/antd";
import "@/assets/styles/image_picker.css";

const ImagePicker = ({
  images = [],
  onAddImage,
  onDeleteImage,
  className = "",
}) => {
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      onAddImage(file);
    }
    e.target.value = "";
  };

  const ImagePickerBox = () => (
    <label
      htmlFor="image-picker"
      className={`
        flex-shrink-0
        flex flex-col items-center justify-center gap-2
        border-2 border-dashed border-gray-300
        rounded-md cursor-pointer
        transition-all duration-200
        hover:border-primary
        bg-secondary
        w-24 h-24 sm:w-32 sm:h-32
      `}>
      <PictureOutlined className="text-2xl text-gray-400" />
      <span className="text-xs text-gray-400">Add New</span>
    </label>
  );

  const SelectedImage = ({ image, index }) => (
    <div className="relative flex-shrink-0 w-24 h-24 sm:w-32 sm:h-32">
      <div className="w-full h-full border-2 border-dashed border-gray-300 rounded-md">
        <img
          src={
            image instanceof File
              ? URL.createObjectURL(image)
              : image.url || image
          }
          alt={`Selected ${index + 1}`}
          className="w-full h-full object-cover rounded-md"
        />
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-1">
          <button
            type="button"
            onClick={() => onDeleteImage(index)}
            className="text-white active:scale-95 transition-transform duration-150">
            <DeleteOutlined className="text-2xl drop-shadow-[0_2px_2px_rgba(0,0,0,0.5)]" />
          </button>
          <span className="text-[10px] text-white text-center px-1 truncate w-full drop-shadow-[0_2px_2px_rgba(0,0,0,0.5)]">
            {image instanceof File ? image.name : image.filename || "Image"}
          </span>
        </div>
      </div>
    </div>
  );

  SelectedImage.propTypes = {
    image: PropTypes.oneOfType([
      PropTypes.instanceOf(File),
      PropTypes.shape({
        url: PropTypes.string,
        filename: PropTypes.string,
        name: PropTypes.string,
      }),
      PropTypes.string,
    ]),
    index: PropTypes.number,
  };

  return (
    <div className={`relative ${className}`}>
      <div className="flex overflow-x-auto gap-4 pb-2 scrollbar-hide">
        <input
          type="file"
          accept="image/*"
          onChange={handleImageChange}
          className="hidden"
          id="image-picker"
        />
        <ImagePickerBox />
        {images.map((image, index) => (
          <SelectedImage key={index} image={image} index={index} />
        ))}
      </div>
    </div>
  );
};

ImagePicker.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.instanceOf(File),
      PropTypes.shape({
        url: PropTypes.string,
        filename: PropTypes.string,
        id: PropTypes.string,
      }),
    ])
  ),
  onAddImage: PropTypes.func,
  onDeleteImage: PropTypes.func,
  className: PropTypes.string,
};

export default ImagePicker;
